function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _class_private_method_get(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return fn;
}
function _class_private_method_init(obj, privateSet) {
    _check_private_redeclaration(obj, privateSet);
    privateSet.add(obj);
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _ts_values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
import { assert, attempt, attemptSync, isFunction, isObject } from '@logosdx/utils';
/**
 * Error thrown when a hook calls `ctx.fail()`.
 *
 * Only created when using the default `handleFail` behavior.
 * If a custom `handleFail` is provided, that error type is thrown instead.
 *
 * @example
 *     hooks.add('validate', (data, ctx) => {
 *         if (!data.isValid) ctx.fail('Validation failed');
 *     });
 *
 *     const [, err] = await attempt(() => engine.run('validate', data));
 *     if (isHookError(err)) {
 *         console.log(err.hookName);  // 'validate'
 *     }
 */ export var HookError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(HookError, Error1);
    function HookError(message) {
        _class_call_check(this, HookError);
        var _this;
        _this = _call_super(this, HookError, [
            message
        ]), /** Name of the hook where the error occurred */ _define_property(_this, "hookName", void 0), /** Original error if `fail()` was called with an Error instance */ _define_property(_this, "originalError", void 0);
        return _this;
    }
    return HookError;
}(_wrap_native_super(Error));
/**
 * Type guard to check if an error is a HookError.
 *
 * @example
 *     const [, err] = await attempt(() => engine.run('validate', data));
 *     if (isHookError(err)) {
 *         console.log(`Hook "${err.hookName}" failed`);
 *     }
 */ export var isHookError = function(error) {
    var _error_constructor;
    return (error === null || error === void 0 ? void 0 : (_error_constructor = error.constructor) === null || _error_constructor === void 0 ? void 0 : _error_constructor.name) === HookError.name;
};
var _data = /*#__PURE__*/ new WeakMap();
/**
 * Request-scoped state bag that flows across hook runs and engine instances.
 *
 * Use symbols for private plugin state and strings for shared cross-plugin contracts.
 *
 * @example
 *     // Private plugin state (symbol key)
 *     const CACHE_STATE = Symbol('cache');
 *     ctx.scope.set(CACHE_STATE, { key, rule });
 *
 *     // Shared cross-plugin contract (string key)
 *     ctx.scope.set('serializedKey', key);
 */ export var HookScope = /*#__PURE__*/ function() {
    "use strict";
    function HookScope() {
        _class_call_check(this, HookScope);
        _class_private_field_init(this, _data, {
            writable: true,
            value: new Map()
        });
    }
    _create_class(HookScope, [
        {
            /**
     * Get a value from the scope.
     *
     * @example
     *     const state = ctx.scope.get<CacheState>(CACHE_STATE);
     */ key: "get",
            value: function get(key) {
                return _class_private_field_get(this, _data).get(key);
            }
        },
        {
            /**
     * Set a value in the scope.
     *
     * @example
     *     ctx.scope.set(CACHE_STATE, { key: 'abc', rule });
     */ key: "set",
            value: function set(key, value) {
                _class_private_field_get(this, _data).set(key, value);
            }
        },
        {
            /**
     * Check if a key exists in the scope.
     */ key: "has",
            value: function has(key) {
                return _class_private_field_get(this, _data).has(key);
            }
        },
        {
            /**
     * Delete a key from the scope.
     */ key: "delete",
            value: function _delete(key) {
                return _class_private_field_get(this, _data).delete(key);
            }
        }
    ]);
    return HookScope;
}();
var EARLY_RETURN = Symbol('early-return');
var _args = /*#__PURE__*/ new WeakMap(), _argsChanged = /*#__PURE__*/ new WeakMap(), _result = /*#__PURE__*/ new WeakMap(), _earlyReturn = /*#__PURE__*/ new WeakMap(), _handleFail = /*#__PURE__*/ new WeakMap(), _hookName = /*#__PURE__*/ new WeakMap(), _removeFn = /*#__PURE__*/ new WeakMap();
/**
 * Context object passed as the last argument to hook callbacks.
 * Provides methods to modify args, short-circuit, fail, or self-remove.
 *
 * @example
 *     // Replace args for downstream callbacks
 *     hooks.add('beforeRequest', (url, opts, ctx) => {
 *         ctx.args(url, { ...opts, cache: 'no-store' });
 *     });
 *
 *     // Short-circuit: replace args AND stop the chain
 *     hooks.add('beforeRequest', (url, opts, ctx) => {
 *         return ctx.args(normalizedUrl, opts);
 *     });
 *
 *     // Short-circuit with a result value
 *     hooks.add('beforeRequest', (url, opts, ctx) => {
 *         const cached = cache.get(url);
 *         if (cached) return ctx.returns(cached);
 *     });
 */ export var HookContext = /*#__PURE__*/ function() {
    "use strict";
    function HookContext(handleFail, hookName, removeFn, scope) {
        _class_call_check(this, HookContext);
        _class_private_field_init(this, _args, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _argsChanged, {
            writable: true,
            value: false
        });
        _class_private_field_init(this, _result, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _earlyReturn, {
            writable: true,
            value: false
        });
        _class_private_field_init(this, _handleFail, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _hookName, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _removeFn, {
            writable: true,
            value: void 0
        });
        /**
     * Request-scoped state bag shared across hook runs and engine instances.
     *
     * @example
     *     // In beforeRequest hook
     *     ctx.scope.set(CACHE_KEY, serializedKey);
     *
     *     // In afterRequest hook (same scope)
     *     const key = ctx.scope.get<string>(CACHE_KEY);
     */ _define_property(this, "scope", void 0);
        _class_private_field_set(this, _handleFail, handleFail);
        _class_private_field_set(this, _hookName, hookName);
        _class_private_field_set(this, _removeFn, removeFn);
        this.scope = scope;
    }
    _create_class(HookContext, [
        {
            /**
     * Replace args for downstream callbacks.
     * When used with `return`, also stops the chain.
     *
     * @example
     *     // Just replace args, continue chain
     *     ctx.args(newUrl, newOpts);
     *
     *     // Replace args AND stop the chain
     *     return ctx.args(newUrl, newOpts);
     */ key: "args",
            value: function args() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                _class_private_field_set(this, _args, args);
                _class_private_field_set(this, _argsChanged, true);
                return EARLY_RETURN;
            }
        },
        {
            /**
     * Set a result value and stop the chain.
     * Always used with `return`.
     *
     * @example
     *     return ctx.returns(cachedResponse);
     */ key: "returns",
            value: function returns(value) {
                _class_private_field_set(this, _result, value);
                _class_private_field_set(this, _earlyReturn, true);
                return EARLY_RETURN;
            }
        },
        {
            /**
     * Abort hook execution with an error.
     * Uses the engine's `handleFail` to create the error.
     *
     * @example
     *     ctx.fail('Validation failed');
     */ key: "fail",
            value: function fail() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _handler_prototype;
                var handler = _class_private_field_get(this, _handleFail);
                var isConstructor = typeof handler === 'function' && ((_handler_prototype = handler.prototype) === null || _handler_prototype === void 0 ? void 0 : _handler_prototype.constructor) === handler;
                var _attemptSync = _sliced_to_array(attemptSync(function() {
                    if (isConstructor) {
                        throw _construct(handler, _to_consumable_array(args));
                    }
                    handler.apply(void 0, _to_consumable_array(args));
                }), 2), error = _attemptSync[1];
                if (error) {
                    if (_instanceof(error, HookError)) {
                        error.hookName = _class_private_field_get(this, _hookName);
                    }
                    throw error;
                }
                throw new HookError('ctx.fail() handler did not throw');
            }
        },
        {
            /**
     * Remove this callback from future runs.
     *
     * @example
     *     hooks.add('init', (config, ctx) => {
     *         bootstrap(config);
     *         ctx.removeHook();
     *     });
     */ key: "removeHook",
            value: function removeHook() {
                _class_private_field_get(this, _removeFn).call(this);
            }
        },
        {
            key: "_argsChanged",
            get: /** @internal */ function get() {
                return _class_private_field_get(this, _argsChanged);
            }
        },
        {
            key: "_newArgs",
            get: /** @internal */ function get() {
                return _class_private_field_get(this, _args);
            }
        },
        {
            key: "_result",
            get: /** @internal */ function get() {
                return _class_private_field_get(this, _result);
            }
        },
        {
            key: "_earlyReturn",
            get: /** @internal */ function get() {
                return _class_private_field_get(this, _earlyReturn);
            }
        }
    ]);
    return HookContext;
}();
var _handleFail1 = /*#__PURE__*/ new WeakMap(), _hookName1 = /*#__PURE__*/ new WeakMap(), _removeFn1 = /*#__PURE__*/ new WeakMap(), _setArgs = /*#__PURE__*/ new WeakMap();
/**
 * Context object passed as the last argument to pipe middleware callbacks.
 * Simpler than HookContext — no `returns()` needed since you control
 * flow by calling or not calling `next()`.
 *
 * @example
 *     hooks.addPipe('execute', async (next, opts, ctx) => {
 *         // Modify opts for inner layers
 *         ctx.args({ ...opts, headers: { ...opts.headers, Auth: token } });
 *
 *         // Call next to continue the chain, or don't to short-circuit
 *         return next();
 *     });
 */ export var PipeContext = /*#__PURE__*/ function() {
    "use strict";
    function PipeContext(handleFail, hookName, removeFn, scope, setArgs) {
        _class_call_check(this, PipeContext);
        _class_private_field_init(this, _handleFail1, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _hookName1, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _removeFn1, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _setArgs, {
            writable: true,
            value: void 0
        });
        /**
     * Request-scoped state bag shared across hook runs and engine instances.
     */ _define_property(this, "scope", void 0);
        _class_private_field_set(this, _handleFail1, handleFail);
        _class_private_field_set(this, _hookName1, hookName);
        _class_private_field_set(this, _removeFn1, removeFn);
        this.scope = scope;
        _class_private_field_set(this, _setArgs, setArgs);
    }
    _create_class(PipeContext, [
        {
            /**
     * Replace args for `next()` and downstream middleware.
     *
     * @example
     *     ctx.args({ ...opts, timeout: 5000 });
     *     return next(); // next receives modified opts
     */ key: "args",
            value: function args() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                _class_private_field_get(this, _setArgs).call(this, args);
            }
        },
        {
            /**
     * Abort execution with an error.
     *
     * @example
     *     ctx.fail('Rate limit exceeded');
     */ key: "fail",
            value: function fail() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _handler_prototype;
                var handler = _class_private_field_get(this, _handleFail1);
                var isConstructor = typeof handler === 'function' && ((_handler_prototype = handler.prototype) === null || _handler_prototype === void 0 ? void 0 : _handler_prototype.constructor) === handler;
                var _attemptSync = _sliced_to_array(attemptSync(function() {
                    if (isConstructor) {
                        throw _construct(handler, _to_consumable_array(args));
                    }
                    handler.apply(void 0, _to_consumable_array(args));
                }), 2), error = _attemptSync[1];
                if (error) {
                    if (_instanceof(error, HookError)) {
                        error.hookName = _class_private_field_get(this, _hookName1);
                    }
                    throw error;
                }
                throw new HookError('ctx.fail() handler did not throw');
            }
        },
        {
            /**
     * Remove this middleware from future runs.
     */ key: "removeHook",
            value: function removeHook() {
                _class_private_field_get(this, _removeFn1).call(this);
            }
        }
    ]);
    return PipeContext;
}();
var _hooks = /*#__PURE__*/ new WeakMap(), _handleFail2 = /*#__PURE__*/ new WeakMap(), _registered = /*#__PURE__*/ new WeakMap(), _callCounts = /*#__PURE__*/ new WeakMap(), /**
     * Validate that a hook name is registered (when strict mode is active).
     */ _assertRegistered = /*#__PURE__*/ new WeakSet(), /**
     * Process a HookContext after a callback has run.
     */ _processCtx = /*#__PURE__*/ new WeakSet(), /**
     * Check times limit and increment counter. Returns true if exceeded.
     */ _checkTimes = /*#__PURE__*/ new WeakSet(), /**
     * Insert a hook entry into its priority-ordered array (lower priority first)
     * and return the cleanup function that removes it. Shared by `add()` and
     * `addPipe()` — same storage, different callback shape.
     */ _insertEntry = /*#__PURE__*/ new WeakSet(), /**
     * Remove an entry from the hooks array.
     */ _removeEntry = /*#__PURE__*/ new WeakSet(), /**
     * Extract RunOptions from the args array if present.
     */ _extractRunOptions = /*#__PURE__*/ new WeakSet();
/**
 * A lightweight, type-safe lifecycle hook system.
 *
 * HookEngine allows you to define lifecycle events and subscribe to them.
 * Callbacks receive spread arguments with a context object as the last param.
 *
 * @example
 *     interface FetchLifecycle {
 *         beforeRequest(url: string, options: RequestInit): Promise<Response>;
 *         afterRequest(response: Response, url: string): Promise<Response>;
 *     }
 *
 *     const hooks = new HookEngine<FetchLifecycle>();
 *
 *     hooks.add('beforeRequest', (url, opts, ctx) => {
 *         ctx.args(url, { ...opts, headers: { ...opts.headers, 'X-Token': token } });
 *     });
 *
 *     hooks.add('beforeRequest', (url, opts, ctx) => {
 *         const cached = cache.get(url);
 *         if (cached) return ctx.returns(cached);
 *     });
 *
 *     const pre = await hooks.run('beforeRequest', url, options);
 *     if (pre.returned) return pre.result;
 *     const response = await fetch(...pre.args);
 *
 * @typeParam Lifecycle - Interface defining the lifecycle hooks
 * @typeParam FailArgs - Arguments type for ctx.fail() (default: [string])
 */ export var HookEngine = /*#__PURE__*/ function() {
    "use strict";
    function HookEngine() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _class_call_check(this, HookEngine);
        _class_private_method_init(this, _assertRegistered);
        _class_private_method_init(this, _processCtx);
        _class_private_method_init(this, _checkTimes);
        _class_private_method_init(this, _insertEntry);
        _class_private_method_init(this, _removeEntry);
        _class_private_method_init(this, _extractRunOptions);
        _class_private_field_init(this, _hooks, {
            writable: true,
            value: new Map()
        });
        _class_private_field_init(this, _handleFail2, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _registered, {
            writable: true,
            value: null
        });
        _class_private_field_init(this, _callCounts, {
            writable: true,
            value: new WeakMap()
        });
        var _options_handleFail;
        _class_private_field_set(this, _handleFail2, (_options_handleFail = options.handleFail) !== null && _options_handleFail !== void 0 ? _options_handleFail : function(message) {
            throw new HookError(message);
        });
    }
    _create_class(HookEngine, [
        {
            /**
     * Register hook names for runtime validation.
     * Once any hooks are registered, all hooks must be registered before use.
     *
     * @param names - Hook names to register
     * @returns this (for chaining)
     *
     * @example
     *     const hooks = new HookEngine<FetchLifecycle>()
     *         .register('beforeRequest', 'afterRequest');
     *
     *     hooks.add('beforeRequest', cb);     // OK
     *     hooks.add('beforeRequset', cb);     // Error: not registered (typo caught!)
     */ key: "register",
            value: function register() {
                for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
                    names[_key] = arguments[_key];
                }
                assert(names.length > 0, 'register() requires at least one hook name');
                if (_class_private_field_get(this, _registered) === null) {
                    _class_private_field_set(this, _registered, new Set());
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = names[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var name = _step.value;
                        assert(typeof name === 'string', "Hook name must be a string, got ".concat(typeof name === "undefined" ? "undefined" : _type_of(name)));
                        _class_private_field_get(this, _registered).add(name);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return this;
            }
        },
        {
            /**
     * Subscribe to a lifecycle hook.
     *
     * @param name - Name of the lifecycle hook
     * @param callback - Callback function receiving spread args + ctx
     * @param options - Options for this subscription
     * @returns Cleanup function to remove the subscription
     *
     * @example
     *     // Simple callback
     *     const cleanup = hooks.add('beforeRequest', (url, opts, ctx) => {
     *         console.log('Request:', url);
     *     });
     *
     *     // With options
     *     hooks.add('analytics', (event, ctx) => {
     *         track(event);
     *     }, { once: true, ignoreOnFail: true });
     *
     *     // With priority (lower runs first)
     *     hooks.add('beforeRequest', cb, { priority: -10 });
     *
     *     // Remove subscription
     *     cleanup();
     */ key: "add",
            value: function add(name, callback) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                assert(typeof name === 'string', '"name" must be a string');
                assert(isFunction(callback), '"callback" must be a function');
                _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'add');
                return _class_private_method_get(this, _insertEntry, insertEntry).call(this, name, callback, options);
            }
        },
        {
            /**
     * Subscribe pipe middleware to a lifecycle hook, typed against the lifecycle's
     * `(next, ...args, ctx)` shape so retry/dedupe-style wrappers register without
     * `as any` or `@ts-expect-error`.
     *
     * Stores into the same registry `add()` uses — `pipe()`/`pipeSync()` already
     * invoke whatever is stored there, so this is a type-level fix, not a new
     * runtime path.
     *
     * @param name - Name of the lifecycle hook
     * @param callback - Middleware receiving `(next, ...args, ctx)`
     * @param options - Options for this subscription
     * @returns Cleanup function to remove the subscription
     *
     * @example
     *     // Retry middleware: call next(), retry on failure
     *     hooks.addPipe('execute', async (next, opts, ctx) => {
     *         for (let i = 0; i < 3; i++) {
     *             const [result, err] = await attempt(next);
     *             if (!err) return result;
     *             await wait(1000 * i);
     *         }
     *         throw lastError;
     *     }, { priority: -20 });
     *
     *     // Dedupe middleware: short-circuit by not calling next()
     *     hooks.addPipe('execute', async (next, opts, ctx) => {
     *         const inflight = getInflight(key);
     *         if (inflight) return inflight;
     *         return next();
     *     }, { priority: -30 });
     */ key: "addPipe",
            value: function addPipe(name, callback) {
                var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                assert(typeof name === 'string', '"name" must be a string');
                assert(isFunction(callback), '"callback" must be a function');
                _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'addPipe');
                return _class_private_method_get(this, _insertEntry, insertEntry).call(this, name, callback, options);
            }
        },
        {
            key: "run",
            value: /**
     * Run all callbacks for a hook asynchronously.
     *
     * @param name - Name of the lifecycle hook to run
     * @param args - Arguments to pass to callbacks (spread + ctx)
     * @returns RunResult with final args, result, and returned flag
     *
     * @example
     *     const pre = await hooks.run('beforeRequest', url, options);
     *     if (pre.returned) return pre.result;
     *     const response = await fetch(...pre.args);
     */ function run(name) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _async_to_generator(function() {
                    var _this, _class_private_method_get_call, realArgs, runOptions, currentArgs, _runOptions_scope, scope, hooks, entries, result, returned, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _this1, _loop, _iterator, _step, _ret, err;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this = this;
                                _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'run');
                                _class_private_method_get_call = _class_private_method_get(this, _extractRunOptions, extractRunOptions).call(this, args), realArgs = _class_private_method_get_call.realArgs, runOptions = _class_private_method_get_call.runOptions;
                                currentArgs = realArgs;
                                scope = (_runOptions_scope = runOptions === null || runOptions === void 0 ? void 0 : runOptions.scope) !== null && _runOptions_scope !== void 0 ? _runOptions_scope : new HookScope();
                                hooks = _class_private_field_get(this, _hooks).get(name);
                                entries = hooks ? _to_consumable_array(hooks) : [];
                                if (runOptions === null || runOptions === void 0 ? void 0 : runOptions.append) {
                                    entries.push({
                                        callback: runOptions.append,
                                        options: {},
                                        priority: Infinity
                                    });
                                }
                                returned = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _loop = function() {
                                    var entry, callback, opts, timesExceeded, removeFn, ctx, _ref, _$err, signal;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                entry = _step.value;
                                                callback = entry.callback, opts = entry.options;
                                                timesExceeded = _class_private_method_get(_this1, _checkTimes, checkTimes).call(_this1, callback, opts);
                                                if (timesExceeded) {
                                                    _class_private_method_get(_this1, _removeEntry, removeEntry).call(_this1, name, entry);
                                                    return [
                                                        2,
                                                        "continue"
                                                    ];
                                                }
                                                removeFn = function() {
                                                    return _class_private_method_get(_this, _removeEntry, removeEntry).call(_this, name, entry);
                                                };
                                                ctx = new HookContext(_class_private_field_get(_this1, _handleFail2), String(name), removeFn, scope);
                                                if (!opts.ignoreOnFail) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    attempt(function() {
                                                        return _async_to_generator(function() {
                                                            var signal;
                                                            return _ts_generator(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            callback.apply(void 0, _to_consumable_array(currentArgs).concat([
                                                                                ctx
                                                                            ]))
                                                                        ];
                                                                    case 1:
                                                                        signal = _state.sent();
                                                                        _class_private_method_get(this, _processCtx, processCtx).call(this, ctx, signal, function(a) {
                                                                            currentArgs = a;
                                                                        }, function(r) {
                                                                            result = r;
                                                                        }, function() {
                                                                            returned = true;
                                                                        });
                                                                        return [
                                                                            2
                                                                        ];
                                                                }
                                                            });
                                                        }).call(_this);
                                                    })
                                                ];
                                            case 1:
                                                _ref = _sliced_to_array.apply(void 0, [
                                                    _state.sent(),
                                                    2
                                                ]), _$err = _ref[1];
                                                if (!_$err && opts.once) removeFn();
                                                if (returned) return [
                                                    2,
                                                    "break"
                                                ];
                                                return [
                                                    2,
                                                    "continue"
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    callback.apply(void 0, _to_consumable_array(currentArgs).concat([
                                                        ctx
                                                    ]))
                                                ];
                                            case 3:
                                                signal = _state.sent();
                                                _class_private_method_get(_this1, _processCtx, processCtx).call(_this1, ctx, signal, function(a) {
                                                    currentArgs = a;
                                                }, function(r) {
                                                    result = r;
                                                }, function() {
                                                    returned = true;
                                                });
                                                if (opts.once) removeFn();
                                                if (returned) return [
                                                    2,
                                                    "break"
                                                ];
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                };
                                _iterator = entries[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                    3,
                                    5
                                ];
                                _this1 = this;
                                return [
                                    5,
                                    _ts_values(_loop())
                                ];
                            case 3:
                                _ret = _state.sent();
                                if (_ret === "break") return [
                                    3,
                                    5
                                ];
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError = true;
                                _iteratorError = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2,
                                    {
                                        args: currentArgs,
                                        result: result,
                                        returned: returned,
                                        scope: scope
                                    }
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            /**
     * Run all callbacks for a hook synchronously.
     *
     * @param name - Name of the lifecycle hook to run
     * @param args - Arguments to pass to callbacks (spread + ctx)
     * @returns RunResult with final args, result, and returned flag
     *
     * @example
     *     const pre = hooks.runSync('beforeValidation', data);
     *     if (pre.returned) return pre.result;
     */ key: "runSync",
            value: function runSync(name) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'runSync');
                var _class_private_method_get_call = _class_private_method_get(this, _extractRunOptions, extractRunOptions).call(this, args), realArgs = _class_private_method_get_call.realArgs, runOptions = _class_private_method_get_call.runOptions;
                var currentArgs = realArgs;
                var _runOptions_scope;
                var scope = (_runOptions_scope = runOptions === null || runOptions === void 0 ? void 0 : runOptions.scope) !== null && _runOptions_scope !== void 0 ? _runOptions_scope : new HookScope();
                var hooks = _class_private_field_get(this, _hooks).get(name);
                var entries = hooks ? _to_consumable_array(hooks) : [];
                if (runOptions === null || runOptions === void 0 ? void 0 : runOptions.append) {
                    entries.push({
                        callback: runOptions.append,
                        options: {},
                        priority: Infinity
                    });
                }
                var result;
                var returned = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    var _this1, _loop = function() {
                        var entry = _step.value;
                        var callback = entry.callback, opts = entry.options;
                        var timesExceeded = _class_private_method_get(_this1, _checkTimes, checkTimes).call(_this1, callback, opts);
                        if (timesExceeded) {
                            _class_private_method_get(_this1, _removeEntry, removeEntry).call(_this1, name, entry);
                            return "continue";
                        }
                        var removeFn = function() {
                            return _class_private_method_get(_this, _removeEntry, removeEntry).call(_this, name, entry);
                        };
                        var ctx = new HookContext(_class_private_field_get(_this1, _handleFail2), String(name), removeFn, scope);
                        if (opts.ignoreOnFail) {
                            var _attemptSync = _sliced_to_array(attemptSync(function() {
                                var signal = callback.apply(void 0, _to_consumable_array(currentArgs).concat([
                                    ctx
                                ]));
                                _class_private_method_get(_this, _processCtx, processCtx).call(_this, ctx, signal, function(a) {
                                    currentArgs = a;
                                }, function(r) {
                                    result = r;
                                }, function() {
                                    returned = true;
                                });
                            }), 2), _$err = _attemptSync[1];
                            if (!_$err && opts.once) removeFn();
                            if (returned) return "break";
                            return "continue";
                        }
                        var signal = callback.apply(void 0, _to_consumable_array(currentArgs).concat([
                            ctx
                        ]));
                        _class_private_method_get(_this1, _processCtx, processCtx).call(_this1, ctx, signal, function(a) {
                            currentArgs = a;
                        }, function(r) {
                            result = r;
                        }, function() {
                            returned = true;
                        });
                        if (opts.once) removeFn();
                        if (returned) return "break";
                    };
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _ret = (_this1 = this, _loop());
                        if (_ret === "break") break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return {
                    args: currentArgs,
                    result: result,
                    returned: returned,
                    scope: scope
                };
            }
        },
        {
            /**
     * Wrap an async function with pre/post lifecycle hooks.
     *
     * - Pre hook: called with function args, can modify args or return early
     * - Post hook: called with `(result, ...originalArgs)`, can transform result
     *
     * @param fn - The async function to wrap
     * @param hooks - Object with optional pre and post hook names
     * @returns Wrapped function with same signature
     *
     * @example
     *     const wrappedFetch = hooks.wrap(
     *         async (url: string, opts: RequestInit) => fetch(url, opts),
     *         { pre: 'beforeRequest', post: 'afterRequest' }
     *     );
     */ key: "wrap",
            value: function wrap(fn, hooks) {
                var _this = this;
                assert(hooks.pre || hooks.post, 'wrap() requires at least one of "pre" or "post" hooks');
                if (hooks.pre) _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, hooks.pre, 'wrap');
                if (hooks.post) _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, hooks.post, 'wrap');
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return _async_to_generator(function() {
                        var currentArgs, preResult, result, postResult;
                        return _ts_generator(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    currentArgs = args;
                                    if (!hooks.pre) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        this.run.apply(this, [
                                            hooks.pre
                                        ].concat(_to_consumable_array(currentArgs)))
                                    ];
                                case 1:
                                    preResult = _state.sent();
                                    currentArgs = preResult.args;
                                    if (preResult.returned && preResult.result !== undefined) {
                                        return [
                                            2,
                                            preResult.result
                                        ];
                                    }
                                    _state.label = 2;
                                case 2:
                                    return [
                                        4,
                                        fn.apply(void 0, _to_consumable_array(currentArgs))
                                    ];
                                case 3:
                                    result = _state.sent();
                                    if (!hooks.post) return [
                                        3,
                                        5
                                    ];
                                    return [
                                        4,
                                        this.run.apply(this, [
                                            hooks.post
                                        ].concat(_to_consumable_array([
                                            result
                                        ].concat(_to_consumable_array(currentArgs)))))
                                    ];
                                case 4:
                                    postResult = _state.sent();
                                    if (postResult.returned) {
                                        return [
                                            2,
                                            postResult.result
                                        ];
                                    }
                                    _state.label = 5;
                                case 5:
                                    return [
                                        2,
                                        result
                                    ];
                            }
                        });
                    }).call(_this);
                };
            }
        },
        {
            /**
     * Wrap a synchronous function with pre/post lifecycle hooks.
     *
     * @param fn - The sync function to wrap
     * @param hooks - Object with optional pre and post hook names
     * @returns Wrapped function with same signature
     *
     * @example
     *     const wrappedValidate = hooks.wrapSync(
     *         (data: UserData) => validate(data),
     *         { pre: 'beforeValidate' }
     *     );
     */ key: "wrapSync",
            value: function wrapSync(fn, hooks) {
                var _this = this;
                assert(hooks.pre || hooks.post, 'wrapSync() requires at least one of "pre" or "post" hooks');
                if (hooks.pre) _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, hooks.pre, 'wrapSync');
                if (hooks.post) _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, hooks.post, 'wrapSync');
                return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var currentArgs = args;
                    if (hooks.pre) {
                        var preResult = _this.runSync.apply(_this, [
                            hooks.pre
                        ].concat(_to_consumable_array(currentArgs)));
                        currentArgs = preResult.args;
                        if (preResult.returned && preResult.result !== undefined) {
                            return preResult.result;
                        }
                    }
                    var result = fn.apply(void 0, _to_consumable_array(currentArgs));
                    if (hooks.post) {
                        var postResult = _this.runSync.apply(_this, [
                            hooks.post
                        ].concat(_to_consumable_array([
                            result
                        ].concat(_to_consumable_array(currentArgs)))));
                        if (postResult.returned) {
                            return postResult.result;
                        }
                    }
                    return result;
                };
            }
        },
        {
            key: "pipe",
            value: /**
     * Execute middleware hooks as an onion (nested) composition.
     *
     * Unlike `run()` which executes hooks linearly, `pipe()` composes hooks
     * as nested middleware. Each hook receives a `next` function that calls
     * the next layer. The innermost layer is `coreFn`. Control flow is
     * managed by calling or not calling `next()` — no `ctx.returns()` needed.
     *
     * Hooks execute in priority order (lower first = outermost layer).
     *
     * @param name - Name of the lifecycle hook
     * @param coreFn - The innermost function to wrap
     * @param args - Arguments passed to each middleware
     * @returns The result from the middleware chain
     *
     * @example
     *     // Retry plugin wraps the fetch call
     *     hooks.addPipe('execute', async (next, opts, ctx) => {
     *         for (let i = 0; i < 3; i++) {
     *             const [result, err] = await attempt(next);
     *             if (!err) return result;
     *             await wait(1000 * i);
     *         }
     *         throw lastError;
     *     }, { priority: -20 });
     *
     *     // Dedupe plugin wraps retry
     *     hooks.addPipe('execute', async (next, opts, ctx) => {
     *         const inflight = getInflight(key);
     *         if (inflight) return inflight;
     *         const result = await next();
     *         share(result);
     *         return result;
     *     }, { priority: -30 });
     *
     *     // Execute: dedupe( retry( makeCall() ) )
     *     const response = await hooks.pipe(
     *         'execute',
     *         () => makeCall(opts),
     *         opts
     *     );
     */ function pipe(name, coreFn) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                return _async_to_generator(function() {
                    var _this, _class_private_method_get_call, realArgs, runOptions, _runOptions_scope, scope, hooks, entries, currentArgs, buildChain;
                    return _ts_generator(this, function(_state) {
                        _this = this;
                        _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'pipe');
                        _class_private_method_get_call = _class_private_method_get(this, _extractRunOptions, extractRunOptions).call(this, args), realArgs = _class_private_method_get_call.realArgs, runOptions = _class_private_method_get_call.runOptions;
                        scope = (_runOptions_scope = runOptions === null || runOptions === void 0 ? void 0 : runOptions.scope) !== null && _runOptions_scope !== void 0 ? _runOptions_scope : new HookScope();
                        hooks = _class_private_field_get(this, _hooks).get(name);
                        entries = hooks ? _to_consumable_array(hooks) : [];
                        if (runOptions === null || runOptions === void 0 ? void 0 : runOptions.append) {
                            entries.push({
                                callback: runOptions.append,
                                options: {},
                                priority: Infinity
                            });
                        }
                        currentArgs = realArgs;
                        buildChain = function(index) {
                            if (index >= entries.length) return coreFn;
                            return function() {
                                return _async_to_generator(function() {
                                    var _this, entry, callback, opts, timesExceeded, removeFn, ctx, next, cb, _ref, result, err, result1;
                                    return _ts_generator(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _this = this;
                                                entry = entries[index];
                                                callback = entry.callback, opts = entry.options;
                                                timesExceeded = _class_private_method_get(this, _checkTimes, checkTimes).call(this, callback, opts);
                                                if (timesExceeded) {
                                                    _class_private_method_get(this, _removeEntry, removeEntry).call(this, name, entry);
                                                    return [
                                                        2,
                                                        buildChain(index + 1)()
                                                    ];
                                                }
                                                removeFn = function() {
                                                    return _class_private_method_get(_this, _removeEntry, removeEntry).call(_this, name, entry);
                                                };
                                                ctx = new PipeContext(_class_private_field_get(this, _handleFail2), String(name), removeFn, scope, function(newArgs) {
                                                    currentArgs = newArgs;
                                                });
                                                next = buildChain(index + 1);
                                                cb = callback;
                                                if (!opts.ignoreOnFail) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    attempt(function() {
                                                        return _async_to_generator(function() {
                                                            return _ts_generator(this, function(_state) {
                                                                return [
                                                                    2,
                                                                    cb.apply(void 0, [
                                                                        next
                                                                    ].concat(_to_consumable_array(currentArgs), [
                                                                        ctx
                                                                    ]))
                                                                ];
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _ref = _sliced_to_array.apply(void 0, [
                                                    _state.sent(),
                                                    2
                                                ]), result = _ref[0], err = _ref[1];
                                                if (opts.once) removeFn();
                                                if (err) return [
                                                    2,
                                                    next()
                                                ];
                                                return [
                                                    2,
                                                    result
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    cb.apply(void 0, [
                                                        next
                                                    ].concat(_to_consumable_array(currentArgs), [
                                                        ctx
                                                    ]))
                                                ];
                                            case 3:
                                                result1 = _state.sent();
                                                if (opts.once) removeFn();
                                                return [
                                                    2,
                                                    result1
                                                ];
                                        }
                                    });
                                }).call(_this);
                            };
                        };
                        return [
                            2,
                            buildChain(0)()
                        ];
                    });
                }).call(this);
            }
        },
        {
            /**
     * Synchronous version of `pipe()`.
     *
     * @param name - Name of the lifecycle hook
     * @param coreFn - The innermost function to wrap
     * @param args - Arguments passed to each middleware
     * @returns The result from the middleware chain
     */ key: "pipeSync",
            value: function pipeSync(name, coreFn) {
                var _this = this;
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                _class_private_method_get(this, _assertRegistered, assertRegistered).call(this, name, 'pipeSync');
                var _class_private_method_get_call = _class_private_method_get(this, _extractRunOptions, extractRunOptions).call(this, args), realArgs = _class_private_method_get_call.realArgs, runOptions = _class_private_method_get_call.runOptions;
                var _runOptions_scope;
                var scope = (_runOptions_scope = runOptions === null || runOptions === void 0 ? void 0 : runOptions.scope) !== null && _runOptions_scope !== void 0 ? _runOptions_scope : new HookScope();
                var hooks = _class_private_field_get(this, _hooks).get(name);
                var entries = hooks ? _to_consumable_array(hooks) : [];
                if (runOptions === null || runOptions === void 0 ? void 0 : runOptions.append) {
                    entries.push({
                        callback: runOptions.append,
                        options: {},
                        priority: Infinity
                    });
                }
                var currentArgs = realArgs;
                var buildChain = function(index) {
                    if (index >= entries.length) return coreFn;
                    return function() {
                        var entry = entries[index];
                        var callback = entry.callback, opts = entry.options;
                        var timesExceeded = _class_private_method_get(_this, _checkTimes, checkTimes).call(_this, callback, opts);
                        if (timesExceeded) {
                            _class_private_method_get(_this, _removeEntry, removeEntry).call(_this, name, entry);
                            return buildChain(index + 1)();
                        }
                        var removeFn = function() {
                            return _class_private_method_get(_this, _removeEntry, removeEntry).call(_this, name, entry);
                        };
                        var ctx = new PipeContext(_class_private_field_get(_this, _handleFail2), String(name), removeFn, scope, function(newArgs) {
                            currentArgs = newArgs;
                        });
                        var next = buildChain(index + 1);
                        var cb = callback;
                        if (opts.ignoreOnFail) {
                            var _attemptSync = _sliced_to_array(attemptSync(function() {
                                return cb.apply(void 0, [
                                    next
                                ].concat(_to_consumable_array(currentArgs), [
                                    ctx
                                ]));
                            }), 2), result = _attemptSync[0], err = _attemptSync[1];
                            if (opts.once) removeFn();
                            if (err) return next();
                            return result;
                        }
                        var result1 = cb.apply(void 0, [
                            next
                        ].concat(_to_consumable_array(currentArgs), [
                            ctx
                        ]));
                        if (opts.once) removeFn();
                        return result1;
                    };
                };
                return buildChain(0)();
            }
        },
        {
            /**
     * Clear all hooks and reset registration state.
     *
     * @example
     *     hooks.add('beforeRequest', validator);
     *     hooks.clear();
     *     // All hooks removed, back to permissive mode
     */ key: "clear",
            value: function clear() {
                _class_private_field_get(this, _hooks).clear();
                _class_private_field_set(this, _registered, null);
                _class_private_field_set(this, _callCounts, new WeakMap());
            }
        }
    ]);
    return HookEngine;
}();
function assertRegistered(name, method) {
    if (_class_private_field_get(this, _registered) !== null && !_class_private_field_get(this, _registered).has(name)) {
        var registered = _to_consumable_array(_class_private_field_get(this, _registered)).map(String).join(', ');
        throw new Error('Hook "'.concat(String(name), '" is not registered. ') + 'Call register("'.concat(String(name), '") before using ').concat(method, "(). ") + "Registered hooks: ".concat(registered || '(none)'));
    }
}
function processCtx(ctx, signal, setArgs, setResult, setReturned) {
    if (ctx._earlyReturn) {
        setResult(ctx._result);
        setReturned();
        return;
    }
    if (ctx._argsChanged) {
        setArgs(ctx._newArgs);
        if (signal === EARLY_RETURN) {
            setReturned();
        }
    }
}
function checkTimes(callback, opts) {
    if (opts.times === undefined) return false;
    var _class_private_field_get_get;
    var count = (_class_private_field_get_get = _class_private_field_get(this, _callCounts).get(callback)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : 0;
    if (count >= opts.times) return true;
    _class_private_field_get(this, _callCounts).set(callback, count + 1);
    return false;
}
function insertEntry(name, callback, options) {
    var _this = this;
    var _options_priority;
    var priority = (_options_priority = options.priority) !== null && _options_priority !== void 0 ? _options_priority : 0;
    var entry = {
        callback: callback,
        options: options,
        priority: priority
    };
    var _class_private_field_get_get;
    var hooks = (_class_private_field_get_get = _class_private_field_get(this, _hooks).get(name)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : [];
    var inserted = false;
    for(var i = 0; i < hooks.length; i++){
        if (hooks[i].priority > priority) {
            hooks.splice(i, 0, entry);
            inserted = true;
            break;
        }
    }
    if (!inserted) {
        hooks.push(entry);
    }
    _class_private_field_get(this, _hooks).set(name, hooks);
    return function() {
        var arr = _class_private_field_get(_this, _hooks).get(name);
        if (arr) {
            var idx = arr.indexOf(entry);
            if (idx !== -1) {
                arr.splice(idx, 1);
            }
        }
    };
}
function removeEntry(name, entry) {
    var arr = _class_private_field_get(this, _hooks).get(name);
    if (arr) {
        var idx = arr.indexOf(entry);
        if (idx !== -1) {
            arr.splice(idx, 1);
        }
    }
}
function extractRunOptions(args) {
    var last = args[args.length - 1];
    if (isObject(last) && ('append' in last && isFunction(last.append) || 'scope' in last && _instanceof(last.scope, HookScope))) {
        return {
            realArgs: args.slice(0, -1),
            runOptions: last
        };
    }
    return {
        realArgs: args,
        runOptions: undefined
    };
}
